package com.fireavert.fire_risk.client.presentation

import com.fireavert.common.ViewModel
import com.fireavert.fire_risk.data_models.TenantFireRiskDataModel
import com.fireavert.properties.shared.data_models.FireClaimData
import com.fireavert.reports_page.shared.data_models.EventTypes
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow

class RiskTableViewModel : ViewModel(), FireRiskScreen {
    private val _viewState = MutableStateFlow(RiskTableViewState())
    val viewState = _viewState.asStateFlow()
    override var propertyMap: Map<String, Int?>
        get() = viewState.value.propertyMap
        set(value) {
            _viewState.value = viewState.value.copy(propertyMap = value)
        }
    override var propertyId: Int?
        get() = viewState.value.propertyId
        set(value) {
            _viewState.value = viewState.value.copy(propertyId = value)
        }
    override var loading: Boolean
        get() = viewState.value.loading
        set(value) {
            _viewState.value = viewState.value.copy(loading = value)
        }
    override var loadingHighRiskTenants: Boolean
        get() = viewState.value.loadingHighRiskTenants
        set(value) {
            _viewState.value = viewState.value.copy(loadingHighRiskTenants = value)
        }
    override var loadingYearlyEvents: Boolean
        get() = viewState.value.loadingYearlyEvents
        set(value) {
            _viewState.value = viewState.value.copy(loadingYearlyEvents = value)
        }
    override var loadingAllTimeEvents: Boolean
        get() = viewState.value.loadingAllTimeEvents
        set(value) {
            _viewState.value = viewState.value.copy(loadingAllTimeEvents = value)
        }
    override var loadingDeviceToEventRatio: Boolean
        get() = viewState.value.loadingDeviceToEventRatio
        set(value) {
            _viewState.value = viewState.value.copy(loadingDeviceToEventRatio = value)
        }
    override var thisYearSmokeEvents: Array<Int>
        get() = viewState.value.thisYearSmokeEvents
        set(value) {
            _viewState.value = viewState.value.copy(thisYearSmokeEvents = value)
        }
    override var thisYearTamperEvents: Array<Int>
        get() = viewState.value.thisYearTamperEvents
        set(value) {
            _viewState.value = viewState.value.copy(thisYearTamperEvents = value)
        }
    override var thisYearLeakEvents: Array<Int>
        get() = viewState.value.thisYearLeakEvents
        set(value) {
            _viewState.value = viewState.value.copy(thisYearLeakEvents = value)
        }
    override var thisYearStoveShutoffEvents: Array<Int>
        get() = viewState.value.thisYearStoveShutoffEvents
        set(value) {
            _viewState.value = viewState.value.copy(thisYearStoveShutoffEvents = value)
        }
    override var eventCount: Int
        get() = viewState.value.eventCount
        set(value) {
            _viewState.value = viewState.value.copy(eventCount = value)
        }
    override var highRiskTenantData: List<TenantFireRiskDataModel>
        get() = viewState.value.fireRiskTenantData
        set(value) {
            _viewState.value = viewState.value.copy(fireRiskTenantData = value)
        }
    override var allTimeAverageEventValue: Double
        get() = viewState.value.allTimeAverageEventValue
        set(value) {
            _viewState.value = viewState.value.copy(allTimeAverageEventValue = value)
        }
    override var averageEventsPerMonth: Double
        get() = viewState.value.averageEventsPerMonth
        set(value) {
            _viewState.value = viewState.value.copy(averageEventsPerMonth = value)
        }
    override var yearStartedUsingFireAvert: Int
        get() = viewState.value.yearStartedUsingFireAvert
        set(value) {
            _viewState.value = viewState.value.copy(yearStartedUsingFireAvert = value)
        }
    override var lastFiveYearClaims: List<FireClaimData>
        get() = viewState.value.lastFiveYearClaims
        set(value) {
            _viewState.value = viewState.value.copy(lastFiveYearClaims = value)
        }
    override var deviceToEventRatio: Array<Double>
        get() = viewState.value.deviceToEventRatio
        set(value) {
            _viewState.value = viewState.value.copy(deviceToEventRatio = value)
        }
    override var firesAvertedCount: Int
        get() = viewState.value.firesAvertedCount
        set(value) {
            _viewState.value = viewState.value.copy(firesAvertedCount = value)
        }
    override var availableDeviceTypes: List<EventTypes>
        get() = viewState.value.availableDeviceTypes
        set(value) {
            _viewState.value = viewState.value.copy(availableDeviceTypes = value)
        }
    override val scope: CoroutineScope
        get() = viewModelScope
}
